import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { CTAContactForm } from "@/components/CTAContactForm";

const STORAGE_KEY = "heroFormDismissed";

export function HeroContactCard() {
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && sessionStorage.getItem(STORAGE_KEY)) {
      setDismissed(true);
    }
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    try {
      sessionStorage.setItem(STORAGE_KEY, "true");
    } catch {}
  };

  const handleReopen = () => {
    setDismissed(false);
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {}
  };

  if (dismissed) {
    return (
      <div className="flex lg:justify-end justify-center">
        <button
          onClick={handleReopen}
          className="bg-secondary text-secondary-foreground rounded-full px-5 py-2 font-semibold shadow-lg hover:opacity-90 transition-opacity"
        >
          Request an Estimate
        </button>
      </div>
    );
  }

  return (
    <div className="relative bg-card/95 backdrop-blur-sm border border-border rounded-xl shadow-2xl p-6 max-w-md w-full mx-auto lg:ml-auto lg:mr-0">
      <button
        onClick={handleDismiss}
        aria-label="Close form"
        className="absolute top-3 right-3 z-10 rounded-full bg-background/80 hover:bg-background border border-border p-1.5 transition-colors"
      >
        <X className="h-4 w-4 text-foreground" />
      </button>
      <CTAContactForm serviceName="Hero Form" />
    </div>
  );
}